import { all, select } from 'redux-saga/effects';
import {
  takeStreamFetch,
  fetchStreamContents,
  createCallbackActionCreator,
} from '../../../Stream/helpers';
import { selectors as withOffsetSelectors } from '../../../Stream/withOffset';
import { selectors as baseSelectors } from '../../../Stream/base';
import { PapiRequestDaUserProfileInitAdoptabobbles } from '@wix/da-papi-types';
import { getCurrentUser } from '../../../publicSession/selectors';

// Create callback action creators for the stream
const fetchNextChooseAvatarDeviations = createCallbackActionCreator(
  'FETCH_NEXT_CHOOSE_AVATAR_DEVIATIONS'
);

function* handleFetchNextChooseAvatarDeviations({
  payload: { streamId },
}: ReturnType<typeof fetchNextChooseAvatarDeviations>) {
  const { offset, limit, currentUser } = yield select(state => ({
    offset: withOffsetSelectors.getNextOffset(state, streamId),
    limit: baseSelectors.getItemsPerFetch(state, streamId),
    currentUser: getCurrentUser(state),
  }));

  if (!currentUser?.username) {
    return;
  }

  yield fetchStreamContents<PapiRequestDaUserProfileInitAdoptabobbles, any>({
    streamId,
    url: 'init/adoptabobbles',
    params: {
      username: currentUser.username,
      page: Math.floor(offset / limit) + 1,
      limit,
    },
    papiProject: 'dauserprofile',
    getStreamData: result => {
      // Extract deviations from the adoptabobbles response
      const deviations =
        result?.gruser?.page?.modules?.find(
          module => module.name === 'adoptabobbles_bought'
        )?.moduleData?.adoptabobblesBought?.deviations || [];

      return {
        hasMore:
          result?.gruser?.page?.modules?.find(
            module => module.name === 'adoptabobbles_bought'
          )?.moduleData?.adoptabobblesBought?.hasMore || false,
        items: deviations,
        offset: offset + deviations.length,
      };
    },
  });
}

export default function* chooseAvatarModalSaga() {
  yield all([
    takeStreamFetch(
      fetchNextChooseAvatarDeviations,
      handleFetchNextChooseAvatarDeviations
    ),
  ]);
}
